export default `
<div class="unauthenticated-container">
  <div class="unauthenticated-alert">
    Please be vigilant. Only provide information via the Platform or to official uTest/Applause domains.  Click <a href="phishing-notice">here</a> for more information.
  </div>
  <div class="unauthenticated-main">
    <unauthenticated-header></unauthenticated-header>
    <div id="mainUiView" class='unauthenticated-view' scrolly scroll-target='#navBar' autoscroll="true">
      <ui-view></ui-view>
    </div>
  </div>
  <unauthenticated-footer></unauthenticated-footer>
</div>
`;
